import { authenticatedApi } from '../../../shared/api/apiClientUtils';

export interface OnboardingStatusResponse {
  userCount: number;
  invitedUserCount: number;
  siteCount: number;
  labourGroupCount: number;
  assignmentCount: number;
  siteAssignmentCount: number;
  gettingStartedCompletedAt: string | null;
}

export interface CompleteOnboardingResponse {
  completedAt: string;
}

export const getOnboardingStatus =
  async (): Promise<OnboardingStatusResponse> => {
    const response = await authenticatedApi.get<OnboardingStatusResponse>(
      '/api/v1/onboarding/status'
    );
    return response.data;
  };

export const completeOnboarding =
  async (): Promise<CompleteOnboardingResponse> => {
    const response = await authenticatedApi.post<CompleteOnboardingResponse>(
      '/api/v1/onboarding/complete'
    );
    return response.data;
  };
